import { useContext } from 'react';
import { contexts } from 'lib_ui-primitives';
const { FormContext } = contexts;
export default () => useContext(FormContext);
